export default "__VITE_ASSET__CCZX0tPf__"